import { BaseHub, tpOnError } from "./BaseHub";
import { IGlobalHubAction } from "./IActions/IGlobalHubAction";

export class GlobalHub extends BaseHub<IGlobalHubAction> {
    constructor(onError: tpOnError) {
        super(onError, "Hubs/Global");
    }
}
